import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { notification } from "antd";
import "../../../static/css/AdminLogin.css";
import waveImg from "../../../static/images/wave.png";
import bgImg from "../../../static/images/bg.svg";
import avatarImg from "../../../static/images/avatar.svg";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const onUserName = (e) => setUsername(e.target.value);
  const onPassword = (e) => setPassword(e.target.value);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
      duration: 3,
    });
  };

  const submitBtn = (e) => {
    e.preventDefault();
    if (username === "info@dhangadiskin.com" && password === "skin12345") {
      Cookies.set("username", username);
      Cookies.set("access", "token");
      Cookies.set("refresh", "token");
      Cookies.set("is_admin", true);
      openNotificationWithIcon("success", "Successfully Logged In.");
      setTimeout(() => {
        navigate("/dashboard/home");
        window.location.reload();
      }, 3000);
    } else {
      openNotificationWithIcon("error", "Email or Password does not match.");
    }
  };

  useEffect(() => {
    const inputs = document.querySelectorAll(".input");

    function addcl() {
      let parent = this.parentNode.parentNode;
      parent.classList.add("focus");
    }

    function remcl() {
      let parent = this.parentNode.parentNode;
      if (this.value === "") {
        parent.classList.remove("focus");
      }
    }

    inputs.forEach((input) => {
      input.addEventListener("focus", addcl);
      input.addEventListener("blur", remcl);
    });

    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("focus", addcl);
        input.removeEventListener("blur", remcl);
      });
    };
  }, []);

  return (
    <div>
      <img className="wave" src={waveImg} alt="wave" />
      <div className="container">
        <div className="img">
          <img src={bgImg} alt="background" />
        </div>
        <div className="login-content">
          <form onSubmit={submitBtn}>
            <img
              src={avatarImg}
              alt="avatar"
              className="ml-[5rem] md:ml-[6rem] lg:ml-[7rem]"
            />
            <h2 className="title">Welcome ADMIN</h2>
            <div className="input-div one">
              <div className="i">
                <i className="fas fa-user"></i>
              </div>
              <div className="div">
                <h5>Username</h5>
                <input
                  type="text"
                  className="input"
                  onChange={onUserName}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="input-div pass">
              <div className="i">
                <i className="fas fa-lock"></i>
              </div>
              <div className="div">
                <h5>Password</h5>
                <input
                  type="password"
                  className="input"
                  onChange={onPassword}
                  autoComplete="off"
                />
              </div>
            </div>
            <input type="submit" className="btn" value="Login" />
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
